module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content row",
    attrs: {
      "id": "UserInvite"
    }
  }, [_c('div', {
    staticClass: "col s12 m11 main-page-content"
  }, [_c('div', {
    staticClass: "col l3 sidebar hide-on-med-and-down"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('user-info')], 1), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('contact')], 1), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('manual')], 1), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('find-us')], 1)]), _vm._v(" "), (_vm.isAgent) ? _c('div', {
    staticClass: "col s12 l9"
  }, [_c('div', {
    staticClass: "card standard-card"
  }, [_c('div', {
    staticClass: "share-info"
  }, [_c('h4', [_vm._v("Link do rejestracji dla współpracowników")]), _vm._v(" "), _c('p', [_vm._v("\n            Skopiuj link i wyślij do swoich współpracowników / agentów OFWCA, którzy będą dla Ciebie pracować.\n          ")]), _vm._v(" "), _c('input-copy-url', {
    attrs: {
      "type": "text",
      "name": "child_agent_registration_url",
      "label": "Link do rejestracji dla współpracowników",
      "value": _vm.child_agent_registration_url + _vm.getMpcCode
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col s12 l9"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card standard-card"
  }, [_c('div', {
    staticClass: "share-info"
  }, [_c('h4', [_vm._v("Link do produktu")]), _vm._v(" "), (_vm.isAnyAgent) ? _c('p', [_vm._v("\n            Skopiuj link i zacznij promować porównywarkę ubezpieczeń komunikacyjnych Punkta.\n          ")]) : _c('p', [_vm._v("\n            Skopiuj link i zacznij promować porównywarkę ubezpieczeń komunikacyjnych Punkta na swojej stronie\n            internetowej, blogu, Youtube, Facebook oraz bazie mailingowej.\n          ")]), _vm._v(" "), _c('input-promo-url', {
    attrs: {
      "type": "text",
      "name": "promo_url",
      "label": "Kod do promowania"
    }
  }), _vm._v(" "), _c('calculate-button')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card standard-card"
  }, [_c('div', {
    staticClass: "share-info"
  }, [_c('h4', [_vm._v("Widget punkta")]), _vm._v(" "), (_vm.isAnyAgent) ? _c('p', [_vm._v("\n            Jeżeli masz swoją stronę Internetową skopiuj poniższy kod i wklej na stronę.\n          ")]) : _c('p', [_vm._v("\n            Skopiuj poniższy kod i wklej na swoją stronę."), _c('br'), _vm._v("Wszystkie kalkulacje oraz opłacone polisy\n            będą automatycznie zliczane i prezentowane w\n            "), _c('router-link', {
    attrs: {
      "to": {
        name: 'yourFunds'
      }
    }
  }, [_vm._v("profilu partnerskim")]), _vm._v("\n            .\n          ")], 1), _vm._v(" "), _c('textarea-promo-widget', {
    attrs: {
      "name": "promo_widget"
    }
  })], 1)]), _vm._v(" "), _c('Banners')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card highlighted-card"
  }, [_c('h4', [_vm._v("Jak to działa?")]), _vm._v(" "), _c('p', [_vm._v("\n          Każdy kto skutecznie poleci produkty Punkta otrzymuje wynagrodzenie."), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Rozpocznij zarabiać na ubezpieczeniach!")]), _vm._v(" Dzięki naszym narzędziom i pomocy jest to\n          proste i efektywne! Nie musisz posiadać wiedzy informatycznej ani ubezpieczeniowej, zajmiemy się wszystkim!\n        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "cooperation-steps"
  }, [_c('div', {
    staticClass: "line hide-on-small-only"
  }), _vm._v(" "), _c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "circle",
    attrs: {
      "number": "1"
    }
  }, [_c('img', {
    staticClass: "inside-circle",
    attrs: {
      "src": require("../../assets/copy.svg"),
      "alt": "email wysłany"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "circle-text"
  }, [_c('h5', {
    staticClass: "key-words"
  }, [_vm._v("Skopiuj link do produktu")])])]), _vm._v(" "), _c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "circle",
    attrs: {
      "number": "2"
    }
  }, [_c('img', {
    staticClass: "inside-circle",
    attrs: {
      "src": require("../../assets/znajomi_icon.svg"),
      "alt": "email wysłany"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "circle-text"
  }, [_c('h5', {
    staticClass: "key-words"
  }, [_vm._v("Promuj i polecaj")])])]), _vm._v(" "), _c('div', {
    staticClass: "step last-step"
  }, [_c('div', {
    staticClass: "circle last-circle",
    attrs: {
      "number": "3"
    }
  }, [_c('img', {
    staticClass: "inside-circle",
    attrs: {
      "src": require("../../assets/wyplac_icon.svg"),
      "alt": "email wysłany"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "circle-text"
  }, [_c('h5', {
    staticClass: "key-words"
  }, [_vm._v("Otrzymuj wynagrodzenie")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fb8e943c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/dashboard/userInvite.vue
// module id = 405
// module chunks = 0